"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ({
  hasFooter
}) => ({
  borderRadius: 'md',
  borderBottomRadius: {
    base: '0',
    tablet: 'md'
  },
  background: 'white',
  color: 'inherit',
  marginY: 0,
  zIndex: 'layer8',
  boxShadow: 'lg',
  paddingBottom: hasFooter ? 0 : 4
});
exports.default = _default;